import React from "react";
import "./footer.css";
import { MdLocationOn } from "react-icons/md";
import { footerData } from "./footerData";
import { Link } from "react-router-dom";
import mpesa from "../../images/payment/mpesa.png";
import kcb from "../../images/payment/kcb.png";
import mastercard from "../../images/payment/mastercard.png";
import visa from "../../images/payment/visa.png";
import airtelmoney from "../../images/payment/airtelmoney.png";

import {
  FaFacebookSquare,
  FaInstagram,
  FaTwitterSquare,
  FaLinkedin,
  FaPhone,
} from "react-icons/fa";

import { SiGmail } from "react-icons/si";

const Footer = () => {
  return (
    <section className="footer">
      <div className="icons mb5">
        <FaFacebookSquare className="socialicon fb" />
        <FaInstagram className="socialicon in" />
        <FaTwitterSquare className="socialicon tw" />
        <FaLinkedin className="socialicon li" />
      </div>

      <div className="cont">
        <div className="name">
          <h1>LAFEMA SYSTEMS</h1>
          <p>
            The only platform you will ever need for your vehicle and fleet
            management needs : intergrated system, kept simple and loved by
            millions of happy users
          </p>

          <h2>Payment Accepted</h2>
          <div className="payments d_flexible">
            <img src={mpesa} alt="" />
            <img src={kcb} alt="" />
            <img src={mastercard} alt="" />
            <img src={visa} alt="" />
            <img src={airtelmoney} alt="" />
          </div>
        </div>
        <div className="useful d_flex">
          {footerData.map((val, index) => (
            <div className="bren" key={index}>
              <h3>{val.title}</h3>
                  <ul>
      {val.text.map((items, itemIndex) => (
        <li key={itemIndex}>
          <Link to={items.link}>{items.list}</Link>
        </li>
      ))}
    </ul>
            </div>
          ))}
        </div>
        <div className="news">
          <h2>News Letter</h2>
          <p>
            Get updates on hot and new deals, offers and promotions delivered
            directly into your inbox. No spam or annoying emails.
          </p>
          <div className="inbut">
            <input type="text" placeholder="Enter email" />
            <button>Subscribe</button>
          </div>
        </div>
      </div>

      <div className="boxesss">
        <div className="callus callone">
          <div className="ff">
            <FaPhone className="fftt" />
          </div>
          <div className="grgr">
            <span>+254-703570519</span>
            <span>Need Help? Call</span>
          </div>
        </div>
        <div className="callus calltwo">
          <div className="ff">
            <SiGmail className="fft" />
          </div>

          <div className="grgr">
            <span>support@lafema.co.ke</span>
            <span>Email us on</span>
          </div>
        </div>
        <div className="callus callone">
          <div className="ff">
            <MdLocationOn className="fftt" />
          </div>
          <div className="grgr">
            <span>Sudi Road - Kakamega Town</span>
            <span>Office Location</span>
          </div>
        </div>
      </div>

      <div className="copright">
        <span>Copright © 2022 Lafema Systems Limited. All rights reserved</span>
      </div>
    </section>
  );
};

export default Footer;
